import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { logout, redirectToSS } from 'actions/authentication';
import { pushGaStepEvent } from 'actions/loan';
import { getRootURL } from 'utils/helpers';
import ThankYouPage from 'components/Credit24/LoanApplication/ThankYou/ThankYouPage';
import {
  CREDIT_APPLICATION_STATE_PENDING,
  CREDIT_APPLICATION_STATE_APPROVED,
} from 'consts/loan/creditApplicationStates';

const contextTypes = {
  router: PropTypes.object,
  intl: PropTypes.object,
};

const ThankYouPageContainer = (props, context) => {
  const dispatch = useDispatch();
  const authentication = useSelector((state) => state.authentication);
  const loan = useSelector((state) => state.loan);

  const logoutUser = (options) => dispatch(logout(options));
  const trackGoogleAnalyticsEvent = (event, data) => dispatch(pushGaStepEvent(event, data));

  const isApproved = loan.state === CREDIT_APPLICATION_STATE_APPROVED;
  const isPending = loan.state === CREDIT_APPLICATION_STATE_PENDING;
  const applicationFlag = INCREASE_APP || isApproved || isPending;

  useEffect(() => {
    if (INCREASE_APP) {
      trackGoogleAnalyticsEvent('checkoutSelfservice', { page: 'thank_you' });
    }
  }, [trackGoogleAnalyticsEvent]);

  const resetApplicationState = () => {
    const redirectPath = `/${location.search}${location.hash}`;
    logoutUser({ redirect: redirectPath });
  };

  const handleReturnToHomepage = () => {
    if (EMBEDDED) {
      logoutUser({ sendMessageToParent: true });
      return;
    }

    if (applicationFlag) {
      redirectToSS();
      return;
    }

    const baseUrl = getRootURL(context.intl.locale);
    const finalReturnLink = PRODUCT_IL ? baseUrl : `${baseUrl}credit-line/`;

    window.location.assign(finalReturnLink);
    resetApplicationState();
  };

  return (
    <div className="container container--mobile-fullWidth">
      <div className="loan-form">
        <ThankYouPage
          authentication={authentication}
          loan={loan}
          handleReturnLink={handleReturnToHomepage}
        />
      </div>
    </div>
  );
};

ThankYouPageContainer.contextTypes = contextTypes;

export default ThankYouPageContainer;
